export type { IBackupConfig as IPcrBackupConfig } from '../../configurations/store/configurations.types'
export { DEFAULT_BACKUP_CONFIG } from '../../configurations/store/configurations.types'

export interface IPcrBackupMetadata {
  pcrId: string
  lastSuccessfulBackupTime: number | null
  lastSuccessfulBackupChecksum: string | null
}

export type IPcrBackupState = IPcrBackupMetadata

export const initialPcrBackupState: IPcrBackupState = {
  pcrId: '',
  lastSuccessfulBackupTime: null,
  lastSuccessfulBackupChecksum: null,
}

export interface IPcrBackupAction {
  type: string
  metadata: IPcrBackupMetadata
}
